/**
 * 异步加载 JS
 * @param {string} url JS链接
 * @param {string} root JS暴露的全局变量
 * @param {function} cb 回调函数
 */
export function asyncJSLoader(url, root, cb) {
  const body = document.querySelector('body');
  const js = document.createElement('script');
  js.type = 'text/javascript';
  js.src = url;
  body.appendChild(js);
  if (window[root]) {
    cb && cb();
  } else {
    const timer = setInterval(() => {
      if (window[root]) {
        clearInterval(timer);
        cb && cb();
      }
    }, 100);
  }
}

/**
 * 获取数据类型
 * @param {*} value
 * @return {string} type [可选值：boolean|date|function|null|number|object|regexp|string|undefined]
 */
export function type(value) {
  return Object.prototype.toString
    .call(value)
    .toLowerCase()
    .match(/\[object\s(\w+)\]/)[1];
}

/**
 * 判断是否是指定类型的数据
 * @param {*} value
 * @param {string} type [可选值：boolean|date|function|null|number|object|regexp|string|undefined]
 * @return 判断结果
 */
export function isType(value, type) {
  const t = type.charAt(0).toUpperCase() + type.slice(1);
  return Object.prototype.toString.call(value) === `[object ${t}]`;
}

/**
 * 判断是否是纯对象
 * @param {*} 待判断的数据
 * @param {boolean} 判断结果
 */
export function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}

/**
 * 判断是否是空对象
 * @param {*} 待判断的数据
 * @param {boolean} 判断结果
 */
export function isEmptyObject(obj) {
  let name;
  for (name in obj) {
    return false;
  }
  return true;
}

/**
 * 合并对象规则同 jQuery
 * @param {target} 目标对象
 * @param {object} 待合并对象（可多个）
 * @return {boolean} 判断结果
 */
export function extend() {
  let src;
  let copyIsArray;
  let copy;
  let name;
  let options;
  let clone;
  let target = arguments[0] || {};
  let i = 1;
  const length = arguments.length;
  let deep = false;
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    i = 2;
  }
  if (typeof target !== 'object' && !type(target, 'function')) {
    target = {};
  }
  if (length === i) {
    target = this;
    --i;
  }
  for (; i < length; i++) {
    if ((options = arguments[i]) !== null) {
      for (name in options) {
        src = target[name];
        copy = options[name];
        if (target === copy) {
          continue;
        }
        if (deep && copy && (isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && Array.isArray(src) ? src : [];
          } else {
            clone = src && isPlainObject(src) ? src : {};
          }
          target[name] = extend(deep, clone, copy);
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}

/**
 * 验证是否是手机号
 * @param {string} 传入手机号字符串
 * @param {boolean} 传出true/false
 */
export function isPhone(number) {
  return /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|166|177|19[8|9])\d{8}$/.test(number);
}

/**
 * 解析?后的url参数
 * @param {string} 传入url
 * @param {object} 传出解析后的参数对象对象
 */
export function parseUrl(url) {
  if (url.indexOf('?') === -1) {
    return {};
  } else {
    const arr = url.split('?')[1].split('&');
    const obj = {};
    for (const i of arr) {
      obj[i.split('=')[0]] = i.split('=')[1];
    }
    return obj;
  }
}

/**
 * 校验是否有xss攻击字符串
 * @param {string} 传入string
 * @param {boolean} 传出是否有非法字符串
 */
export function validateXSS(str) {
  return new RegExp("[%--`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]").test(str);
}

/**
 * 数组随机排序
 * @param {array} 传入数组
 * @param {array} 随机排序后的数组
 */
export function shuffle(arr) {
  const len = arr.length;
  for (let i = 0; i < len - 1; i++) {
    const index = parseInt(Math.random() * (len - i));
    const temp = arr[index];
    arr[index] = arr[len - i - 1];
    arr[len - i - 1] = temp;
  }
  return arr;
}

/**
 * toast，供非app内嵌的端外活动使用
 * @param {msg} 传入toast信息
 */
export function toast(msg) {
  const body = document.querySelector('body');
  body.style.position = 'relative';
  const toastContainer = document.createElement('div');
  toastContainer.style.position = 'fixed';
  toastContainer.style.width = '100%';
  toastContainer.style.height = '100%';
  toastContainer.style.top = '0';
  toastContainer.style.left = '0';
  toastContainer.style.zIndex = '99999';
  const toast = document.createElement('div');
  toast.innerText = msg;
  toast.style.position = 'absolute';
  toast.style.backgroundColor = '#000000';
  toast.style.color = '#ffffff';
  toast.style.left = '50%';
  toast.style.top = '50%';
  toast.style.transform = 'translate(-50%, -50%)';
  toast.style.padding = '10px 10px';
  toast.style.textAlign = 'center';
  toast.style.fontSize = '14px';
  toastContainer.appendChild(toast);
  body.appendChild(toastContainer);
  window.setTimeout(() => {
    body.removeChild(toastContainer);
  }, 3000);
}
